import React, { useEffect, useState, useContext } from "react";
import "./RamlPic.css";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { ramlKey } from "../../data";
import HeaderB from "../../components/headerb/HeaderB";
import { Link, useLocation } from "react-router-dom";
import { MainContext } from "../../contexts/MainContext";
import CircleBtn from "../ramlcircle/CircleBtn";
import apiUrl from "../../utils/ApiConfig";
import DateFormat from "../../utils/DateFormat";
import ScrollToElement from "../../utils/ScrollToElement";
import Tooltip from "@mui/material/Tooltip";
import NatijehLink from "../../utils/NatijehLink";

export default function RamlPic() {
  let {
    userId,
    lotNameCon,
    titleIdCon,
    questionIdCon,
    setZayech,
    zayech,
    zayechB,
    setZayechB,
    setValue16,
    setZayechC,
    titleTopics,
    allQuestions,
    setDateZayeche,
    dateZayeche,
    allSource,
    batnName,
    setBatnName,
    ismyZayeheh,
    setIsMyZayeheh,
    allShaps,
    setAllShaps,
    experience, setExperience,
    result, setResult,
    UserShapeId, setUserShapId,
    setTitleIdCon,
    setLotNameCon,
    setQuestionIdCon,
  } = useContext(MainContext);
  const location = useLocation();

  const [ramlKeys, setRamlKeys] = useState(ramlKey);
  const mainContext = useContext(MainContext);

  const [localData2, setlocalData2] = useState(() => {
    let y = JSON.parse(localStorage.getItem("mainObj2"));
    if (y) {
      return y;
    } else {
      return "";
    }
  });
  const [localData, setlocalData] = useState(() => {
    let x = JSON.parse(localStorage.getItem("mainObject"));
    if (x) {
      return x;
    } else {
      return "";
    }
  });
  const [filterItem1, setFilteritem1] = useState(
    ramlKeys.filter((items) => {
      return items.keynum == localData.raml1;
    })
  );

  const [filterItem2, setFilteritem2] = useState(
    ramlKeys.filter((items) => {
      return items.keynum == localData.raml2;
    })
  );
  const [filterItem3, setFilteritem3] = useState(
    ramlKeys.filter((items) => {
      return items.keynum == localData.raml3;
    })
  );
  const [filterItem4, setFilteritem4] = useState(
    ramlKeys.filter((items) => {
      return items.keynum == localData.raml4;
    })
  );

  const [val, setVal] = useState(() => {
    if (filterItem1.length !== 0 && filterItem2.length !== 0 && filterItem3.length !== 0 && filterItem4.length !== 0) {
      return "" + filterItem1[0].keyA + "" + filterItem2[0].keyA + "" + filterItem3[0].keyA + "" + filterItem4[0].keyA + "";
    }
  });
  const [value, setValue] = useState({ Value: val });
  const [shapCellAtt, setShapCellAtt] = useState([]);
  const [CellAtt, setCellAtt] = useState([]);
  const [shapAtt, setshapAtt] = useState([]);
  const [indexState, setIndexState] = useState(null);
  const [attStateButt, setAttStateButt] = useState("home");
  const [shapeName, setShapeName] = useState("");
  const [shapeSrc, setShapeSrc] = useState("");
  const getShapes = (code4) => {
    let obj = {
      id: 0,
      shapeValue: "string",
      lotName: lotNameCon ? lotNameCon : null,
      result: result ? result : null,
      titleID: titleIdCon ? titleIdCon : null,
      agQuestionId: questionIdCon ? questionIdCon : null,
      userId: userId,

    };
    async function myApp() {
      const res = await fetch(`${apiUrl}/MainCal2?Value=${code4}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      })
        .then((res) => {
          if (res.ok)
            res.json().then((result) => {
              // console.log(result)
              setAllShaps(result.result);
              setZayech(result.result);
              setDateZayeche(result.date);
              setUserShapId(result.userShape.id)  ////ست کردن آیدی زاییچه مشتری 

            });
        })
        .catch((err) => console.log(err));
    }
    myApp();
  };
  const getValue16Code = (obj) => {
    async function myApp() {
      const res = await fetch(`${apiUrl}/MainCal`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      }).then((res) => {
        if (res.ok) {
          return res.json().then((result) => {
            setValue16(result.value);
          });
        }
      });
    }
    myApp();
  };

  const getCellAtt = (positionId) => {
    async function myApp() {
      const res = await fetch(`${apiUrl}/api/AgMain/getCell?position=${positionId}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json().then((result) => {
              setCellAtt(result[0].cellAttributes);
            });
          }
        })
        .catch((err) => console.log(err));
    }
    myApp();
  };

  const getShCellAtt = (ShId, CellId) => {
    async function myApp() {
      const res = await fetch(`${apiUrl}/api/AgShapeCell/getShapeCellByQId?ShId=${ShId}&CellId=${CellId}&TitId=${titleIdCon}&QueID=${questionIdCon}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json().then((result) => {
              setShapCellAtt(result);
            });
          }
        })
        .catch((err) => console.log(err));
    }
    myApp();
  };

  useEffect(() => {
    if (allShaps.length == 0) {

      // setAllShaps([]);
      if (localData2 && !ismyZayeheh) {
        getShapes(localData2.Value);
        getValue16Code(localData2);
      } else if (!ismyZayeheh) {
        getShapes(value.Value);
        getValue16Code(value);
      }
    }
  }, []);

  useEffect(() => {
    ///با خالی کردن استیت زاییچه دوم به هنگام تغییر صفحه نحوه قرار گرفتن زاییچه اول در صفحه به درستی انجام میشه
    setZayechB([]);
    setIsMyZayeheh(false);
    setBatnName("");
  }, [location]);

  useEffect(() => {
    ///وقتی مایزاییچه باز میشود بعد از کلیک بر روی نمایش زاییچه استیتهای مربوط به نمایش اطلاعات زاییچه قبلی ریست میشود
    if (ismyZayeheh) {
      setIndexState(null);
      setCellAtt([]);
      setshapAtt([]);
      setShapCellAtt([]);
    }
  }, [ismyZayeheh]);

  /////////////////////////////////section 2
  return (
    <>
      <Container fluid>
        <HeaderB />
      </Container>

      <Container>
        <Row>
          <Col
            className="ramlpic-colmain"
          // xs={12} md={10}
          >
            <Row style={{ position: "relative" }} className="mt-3 mb-4">
              <Col md={batnName ? 6 : 12}>
                {" "}
                <div className="ramlpic-divimg2 mb-4">
                  <>
                    <div className="ramlpic-div">
                      {allShaps?.length == 0 ? (
                        <>
                          <div className="ramlcircle-loading ">
                            <br /> <br /> <br /> <br /> <br /> <br />
                            <div class="loading">
                              <div class="loading_circle"></div>
                              <div class="loading_circle"></div>
                              <div class="loading_circle"></div>
                            </div>
                            <h1 className="ramlcircle-div2">درحال لود شدن</h1>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="ramlpic1">
                            <div className="ramlpic2">
                              <>
                                {
                                  allShaps.length != 0 && (
                                    <>
                                      <span className="ramlpic2-zname-span">شکل اصلی</span>
                                      <Col>
                                        <Image
                                          thumbnail
                                          style={{
                                            border: "none",
                                            height: "350px",
                                          }}
                                          src="./images/pagePishrafte/chartLine.png"
                                          alt=""
                                        />
                                        {allShaps.map((item, index) => (
                                          <>
                                            {" "}
                                            <div
                                              className={`ramlpic-divapi a${index + 1}`}
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                // console.log(item);
                                                setShapCellAtt([]);
                                                setshapAtt(item.attributes);
                                                getCellAtt(index + 1);
                                                setIndexState(index);
                                                setShapeName(item.name);
                                                setAttStateButt("home");
                                                setShapeSrc(item.src);
                                                if (questionIdCon) {
                                                  getShCellAtt(item.id, index + 1);
                                                }
                                                ScrollToElement("ramlpicCardid");
                                              }}
                                            >
                                              <img
                                                className="ramlpic-imgapi"
                                                // className={indexState !== index ? "ramlpic-imgapi" : "ramlpic-imgapi ramlpic-divapi-active"}
                                                src={item.src}
                                                alt=""
                                              />
                                              {indexState == index && <span className="check-span">✔️</span>}
                                            </div>
                                          </>
                                        ))}
                                      </Col>
                                    </>
                                  )
                                  // )
                                }
                              </>
                            </div>
                            <div style={{ position: "absolute", bottom: "-50px", zIndex: 1000, left: "50%", transform: "translateX(-50%)", width: "40%" }}>
                              <CircleBtn />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                </div>{" "}
              </Col>

              <Col md={6}>
                {" "}
                <div className="ramlpic-divimg2 mb-4">
                  <>
                    <div className="ramlpic-div">
                      {
                        <div className="ramlpic1">
                          <div className="ramlpic2">
                            <>
                              {zayechB?.length !== 0 && mainContext.flag !== false && (
                                <>
                                  <span className="ramlpic2-zname-span">{batnName}</span>
                                  <Col>
                                    <Image
                                      thumbnail
                                      style={{
                                        border: "none",
                                        height: "350px",
                                      }}
                                      src="./images/pagePishrafte/chartLine.png"
                                      alt=""
                                    />
                                    {zayechB.map((item, index) => (
                                      <>
                                        <div className={`ramlpic-divapi a${index + 1}`}>
                                          <img className="ramlpic-imgapi" src={item.src} alt="" />
                                        </div>
                                      </>
                                    ))}
                                  </Col>
                                </>
                              )}
                            </>
                          </div>
                        </div>
                      }
                    </div>
                  </>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="row">
          {/* zayehceh description */}
          <div className="col-md-4  boxSh centercc" style={{ alignSelf: "flex-start", marginTop: "50px" }}>
            <div className="inputA centerrc">
              <span>نام </span>{" "}
              <span type="text" className="inputA centerrc">
                {lotNameCon}
              </span>
            </div>

            <div className="inputA centerrc">
              <span>موضوع </span>{" "}
              <span type="text" className="inputA centerrc">
                {" "}
                {titleTopics?.filter((filter) => filter.id == titleIdCon)[0]?.description}
              </span>
            </div>

            <div className="inputA centerrc">
              <span>سوال </span>{" "}
              <span type="text" className="inputA centerrc">
                {allQuestions?.filter((filter) => filter.id == questionIdCon)[0]?.description}
              </span>
            </div>

            <div className="inputA centerrc">
              <span> تاریخ و ساعت </span>{" "}
              <span type="text" className="inputA centerrc">
                <DateFormat dateString={dateZayeche} />
              </span>
            </div>

            {/* <NatijehLink /> */}
            <Link
              className="linkBtn inputA"
              to="/ramlcircle"
              onClick={() => {
                setZayechB([]);
                setZayechC([]);
              }}
            >
              {" "}
              زایچه دوار{" "}
            </Link>

            <Link className="linkBtn inputA" to="/RamlNazar">
              {" "}
              نظرات نجومی{" "}
            </Link>

            <Link className="linkBtn inputA" to="/RamlJadval">
              قـوت و ضـعـف
            </Link>

            <NatijehLink />

          </div>

          <div className="col-md-8  ">
            <div className="container containerB ">
              <div className="card" id="ramlpicCardid">
                {/* آیکون‌های کناری */}

                <div className="sidebar-icons ">
                  <div className="sidebar-icons-div boxSh centerrc">
                    <Tooltip title="مجموع">
                      <img
                        src="../../../images/headericon/objects-column.png"
                        alt=""
                        className={attStateButt == "home" ? "icon attButActive" : "icon "}
                        style={{ width: "23px" }}
                        id="home"
                        onClick={() => setAttStateButt("home")}
                      />
                    </Tooltip>
                  </div>

                  {/* <CgMenuGridO className={attStateButt == "home" ? "icon attButActive" : "icon "} id="home" onClick={() => setAttStateButt("home")} /> */}

                  <div className="sidebar-icons-div boxSh centerrc">
                    <Tooltip title="خانه">
                      {" "}
                      <img
                        src="../../../images/headericon/homework.png"
                        className={attStateButt == "cell" ? "icon attButActive" : "icon "}
                        onClick={() => setAttStateButt("cell")}
                        id="cell"
                        style={{ width: "23px" }}
                        alt=""
                      />
                    </Tooltip>
                  </div>

                  {/* <MdOutlineFormatShapes className={attStateButt == "cell" ? "icon attButActive" : "icon "} id="cell" onClick={() => setAttStateButt("cell")} /> */}

                  {shapeSrc ? (
                    <div className="sidebar-icons-div boxSh centerrc">
                      <Tooltip title="شکل">
                        <img
                          src={shapeSrc}
                          alt=""
                          style={{ width: "23px" }}
                          className={attStateButt == "shape" ? "icon attButActive" : "icon "}
                          onClick={() => setAttStateButt("shape")}
                          id="shape"
                        />
                      </Tooltip>
                    </div>
                  ) : (
                    <div className="sidebar-icons-div boxSh centerrc">
                      <Tooltip title="شکل">
                        <img src="../../../images/headericon/images.png " alt="" style={{ width: "18px" }} />
                      </Tooltip>
                    </div>
                  )}

                  {/* <FaShapes className={attStateButt == "shape" ? "icon attButActive" : "icon "} id="shape" onClick={() => setAttStateButt("shape")} /> */}

                  <div className="sidebar-icons-div boxSh centerrc">
                    <Tooltip title="شکل در خانه">
                      <img
                        src="../../../images/headericon/homeshape.png"
                        alt=""
                        style={{ width: "23px" }}
                        className={attStateButt == "shapCell" ? "icon attButActive" : "icon "}
                        id="shapCell"
                        onClick={() => setAttStateButt("shapCell")}
                      />
                    </Tooltip>
                    <img
                      src={shapeSrc}
                      alt=""
                      style={{ width: "15px", position: "absolute" }}
                      className={attStateButt == "shapCell" ? "icon attButActive" : "icon "}
                      onClick={() => setAttStateButt("shapCell")}
                      id="shapCell"
                    />
                  </div>

                  {/* <GrObjectGroup className={attStateButt == "shapCell" ? "icon attButActive" : "icon "} id="shapCell" onClick={() => setAttStateButt("shapCell")} /> */}
                </div>

                {/* محتوای اصلی */}
                <div className="content">
                  <div>
                    {CellAtt.length != 0 && (attStateButt == "home" || attStateButt == "cell") && <h2 style={{ color: "var(--them4)" }}>خانه</h2>}

                    {CellAtt.length != 0 &&
                      (attStateButt == "home" || attStateButt == "cell") &&
                      CellAtt.map((item) => (
                        <>
                          <p
                            style={{
                              border: "1px solid var(--them4) ",
                              padding: "5px",
                              borderRadius: "8px",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          ></p>
                        </>
                      ))}
                  </div>
                  <div>
                    {shapAtt.length != 0 && (attStateButt == "home" || attStateButt == "shape") && <h2 style={{ color: "var(--them4)" }}>شکل {shapeName}</h2>}
                    {shapAtt.length != 0 &&
                      (attStateButt == "home" || attStateButt == "shape") &&
                      shapAtt.map((item) => (
                        <>
                          <p
                            style={{
                              border: "1px solid var(--them4) ",
                              padding: "5px",
                              borderRadius: "8px",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          ></p>
                        </>
                      ))}
                  </div>
                  <div>
                    {shapCellAtt.length != 0 && (attStateButt == "home" || attStateButt == "shapCell") && <h2 style={{ color: "var(--them4)" }}>اجتماع در خانه </h2>}
                    {shapCellAtt.length != 0 &&
                      (attStateButt == "home" || attStateButt == "shapCell") &&
                      shapCellAtt.map((item) => (
                        <>
                          <div className="ramlpic-attr-div">
                            <p
                              style={{
                                border: "1px solid var(--them4) ",
                                padding: "5px",
                                borderRadius: "8px",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></p>
                            <span className="ramlpic-attr-div-span">
                              <span>منبع: </span>
                              {allSource.filter((filter) => filter.id == item.sourceID)[0]?.title}
                            </span>
                          </div>
                        </>
                      ))}
                  </div>
                </div>

                {/* دکمه پایین سمت راست */}
                {/* <button className="floating-button">
                  <IoMdArrowDropdown />
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
